import { render, staticRenderFns } from "./SubmissionStage.vue?vue&type=template&id=93faf6ce&scoped=true&"
import script from "./SubmissionStage.vue?vue&type=script&lang=js&"
export * from "./SubmissionStage.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionStage.vue?vue&type=style&index=0&id=93faf6ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93faf6ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
